// Keep the mounted application separate from SoloCrew's routes and API.
export function appBase(): string {
  const path = typeof window === 'undefined' ? '/' : window.location.pathname;
  return path === '/data' || path?.startsWith('/data/') ? '/data' : '';
}

export function appPath(path: string): string {
  if (!path.startsWith('/') || path.startsWith('//')) return path;
  const base = appBase();
  if (base && (path === base || path.startsWith(base + '/'))) return path;
  return base + path;
}

export function appRoute(): string {
  return window.location.pathname.slice(appBase().length) || '/';
}
